import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-gray-500 my-4"
}
const _hoisted_3 = { class: "flex flex-col gap-y-4" }
const _hoisted_4 = {
  key: 1,
  class: "flex gap-x-5 w-full"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-2 text-sm text-red-600"
}

import { computed, onMounted, ref, watch } from "vue"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import GgmsInput from "@/components/GgmsInput.vue"

interface OptionType {
    displayName: string
    value: any
    isOther?: boolean
    otherValue?: string
}

interface Props {
    modelValue: boolean[]
    label?: string
    description?: string
    required?: boolean
    inline?: boolean
    disabled?: boolean
    options: OptionType[]
    name?: string
    invalid?: boolean
    errorMessage?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GgmsCheckBoxList',
  props: {
    modelValue: { default: [] as boolean[] },
    label: { default: "" },
    description: {},
    required: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    options: { default: [] as OptionType[] },
    name: { default: "" },
    invalid: { type: Boolean, default: false },
    errorMessage: {}
  },
  emits: ["update:modelValue", "update:options"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const localInvalid = ref(props.invalid)
const localErrorMessage = ref(props.errorMessage)
const otherValue = ref(props.options.at(-1)?.otherValue || "")

const starStyle = computed(() => [localInvalid.value ? "text-red-600" : "text-gray-700", "pl-1"])
const getRequiredStyleInline = computed(() => (props.inline ? "gap-2" : ""))

const model = computed({
    get() {
        return props.modelValue
    },
    set(value: boolean[]) {
        emit("update:modelValue", value)
    },
})

function getWrapperStyleInline() {
    return props.inline ? "flex items-center gap-4" : ""
}

function getLabelStyleInline() {
    return props.inline ? "w-2/5 whitespace-nowrap pr-2 lg:pr-0" : "mb-4"
}

function setOptionLengthStyle(isOther: boolean | undefined) {
    return isOther ? "w-full" : "w-fit"
}

function changeOtherValue() {
    const index = props.options.length - 1
    model.value[index] = !!otherValue.value?.length
    emit("update:options", otherValue.value)
}

function disableValidationError() {
    localErrorMessage.value = ""
    localInvalid.value = false
}

onMounted(() => {
    if (!props.modelValue.length) {
        model.value = props.options.map(() => false)
    }
})

watch(
    () => props.invalid,
    () => (localInvalid.value = props.invalid)
)

watch(
    () => props.errorMessage,
    () => {
        localErrorMessage.value = props.errorMessage
        localInvalid.value = props.invalid
    }
)

watch(
    () => model.value,
    () => {
        const trueResponses = model.value.filter((response) => response)
        if (trueResponses.length === 0 && props.invalid) {
            localErrorMessage.value = props.errorMessage
            localInvalid.value = props.invalid
        } else {
            disableValidationError()
        }
    },
    { deep: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(getWrapperStyleInline())
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex", getRequiredStyleInline.value])
    }, [
      _createElementVNode("label", {
        for: _ctx.name,
        class: _normalizeClass([getLabelStyleInline(), 'block text-sm font-medium text-gray-700 '])
      }, _toDisplayString(_ctx.label), 11, _hoisted_1),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(starStyle.value)
          }, "*", 2))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.description), 1))
      : _createCommentVNode("", true),
    _createElementVNode("fieldset", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: option.value,
          class: _normalizeClass(["flex items-center justify-start cursor-pointer", setOptionLengthStyle(option?.isOther)])
        }, [
          (!option?.isOther)
            ? (_openBlock(), _createBlock(GgmsCheckBox, {
                key: 0,
                modelValue: model.value[index],
                "onUpdate:modelValue": ($event: any) => ((model.value[index]) = $event),
                id: _ctx.name,
                label: option.displayName,
                disabled: _ctx.disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "label", "disabled"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(GgmsCheckBox, {
                  modelValue: model.value[index],
                  "onUpdate:modelValue": ($event: any) => ((model.value[index]) = $event),
                  id: _ctx.name,
                  label: "Other:",
                  disabled: _ctx.disabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "disabled"]),
                _createVNode(GgmsInput, {
                  modelValue: otherValue.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((otherValue).value = $event)),
                  small: true,
                  disabled: _ctx.disabled,
                  class: "w-full",
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (changeOtherValue()))
                }, null, 8, ["modelValue", "disabled"])
              ]))
        ], 2))
      }), 128))
    ]),
    (localErrorMessage.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(localErrorMessage.value), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})